module.exports = __webpack_public_path__ + "static/media/new-index-logo-text.91fe259c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/eztrader/new-index-logo-text.svg
// module id = 1248
// module chunks = 103